module.exports = __webpack_public_path__ + "img/icon_smart_controller.6d494a8a.png";